<template>
  <div
    class="doctor-restrictions"
    data-qa="lpu_doctors_list_restrictions"
  >
    <div class="doctor-restrictions__body d-flex align-start rounded-sm">
      <span
        class="doctor-restrictions__icon ui-icon-circle-warning"
        aria-hidden="true"
      />
      <div class="py-2 pr-4">
        <div class="text-body-2 text--text mb-1">
          {{ tStatic('Ознакомьтесь с ограничениями на приём у врача в этой клинике') }}
        </div>
        <button
          type="button"
          class="text-link-2 cursor-pointer primary--text link-decoration-underline pa-0"
          data-qa="lpu_doctors_list_restrictions_open"
          @click="isRestrictionsOpen = true"
        >
          {{ tStatic('Смотреть') }}
        </button>
      </div>
    </div>
    <DoctorAppointmentRestrictionsModal
      v-model="isRestrictionsOpen"
      :doctor-id="doctorId"
      :lpu-id="lpu.id"
      :lpu-name="lpuName"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import DoctorAppointmentRestrictionsModal from 'src/components/common/DoctorAppointmentRestrictionsModal/DoctorAppointmentRestrictionsModal.vue'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

const props = defineProps<{
  doctorId: number
  lpu: Lpu
}>()

const isRestrictionsOpen = ref(false)
const lpuName = computed(() => tDynamic(props.lpu, 'name'))
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.doctor-restrictions {
  &__body {
    background-color: rgba($ui-kit-text-warning, 0.12);
    border-left: 6px solid rgba($ui-kit-text-warning, 0.4);
  }

  &__icon {
    margin: 6px 6px 6px 10px;
    color: $ui-kit-text-warning;
  }
}
</style>
